import { generateJobPostingSchema, type JobPostingSchemaInput } from "@/utils/jobSchema";

export interface JobPostingWidgetProps {
  jobs?: JobPostingSchemaInput[];
  singleScriptArray?: boolean;
}

/**
 * Renders JobPosting schema scripts for one or more jobs.
 * - `singleScriptArray=true`: one script containing an array of JobPosting objects
 * - `singleScriptArray=false`: one script per JobPosting object
 */
export default function JobPostingWidget({
  jobs = [],
  singleScriptArray = true,
}: JobPostingWidgetProps) {
  const schemas = (Array.isArray(jobs) ? jobs : [])
    .map((job) => generateJobPostingSchema(job))
    .filter(Boolean);

  if (schemas.length === 0) {
    return null;
  }

  if (singleScriptArray) {
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}
      />
    );
  }

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={`${schema?.title || "job"}-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}

